export default __webpack_public_path__ + "static/img6-f0cd7707a3e51b4717ab1946bc561c3a.png";